import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import employees from 'modules/employees/store/collections/employees'
import memberships from 'modules/teams/store/collections/memberships'
import { membershipEmployee } from 'modules/teams/store/membershipEmployee'
import { membershipIsLead } from 'modules/teams/store/membershipIsLead'
import type { ITeam } from 'modules/teams/store/models/Team'
import { teamMemberships } from 'modules/teams/store/teamMemberships'

import BlankState from './BlankState'
import Leader from './Leader'
import * as styles from './index.vanilla.css'

interface Props {
  team: ITeam
  readonly: boolean
  contractVersions: ContractVersions
}

const Leaders = ({ team, readonly, contractVersions }: Props) => {
  const leaders = teamMemberships(memberships, employees, team.id).filter((membership) =>
    membershipIsLead(employees, membership)
  )
  const hasLeaders = !!leaders.length
  return (
    <Box>
      <Box paddingBottom="s16">
        <Text.Normal color="grey1000" weight="medium" size="200">
          {i18n.t('teams.leaders.title')}
        </Text.Normal>
      </Box>
      {!hasLeaders && (
        <BlankState team={team} readonly={readonly} contractVersions={contractVersions} />
      )}
      {hasLeaders && (
        <Box flexDirection="row" flexWrap="wrap" justifyContent="spaceBetween">
          {leaders.map((leader) => (
            <Box className={styles.leader} key={leader.id}>
              <Leader
                canManageTeams={!readonly}
                membership={leader}
                employee={membershipEmployee(employees, leader)}
                contractVersions={contractVersions}
              />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  )
}

export default observer(Leaders)
